import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '@/views/Main.vue';
import store from "@/store";
const {isNavigationFailure, NavigationFailureType} = VueRouter;

Vue.use(VueRouter);

export const loginPageUrl = location.hostname.endsWith("io") ? "/login/ldap" : '/login';

const routerViewComponent = {
  render(c) {
    return c('router-view');
  }
};

const emptyPage = {
  render(c) {
    return c('div');
  }
};

const emptyMenu = {
  render(c) {
    return "";
  }
};

const routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    children: [
      {
        path: '',
        name: 'DashBoard',
        component: () => import(/* webpackChunkName: "DashBoard" */ '@/components/dashboard/DashBoard'),
        meta: {
          authLevelFromAdAccount: true,
          authNotRequired: true         //대시보드는 자체 권한 체크
        },
        beforeEnter: async (to, from, next) => {
          if (!store.getters.getAuth) {
            await store.dispatch("logout");
          } else {
            await store.dispatch("refreshAdAccountList");
            await store.dispatch('refreshAdminMenu');
            if (store.getters.getAuthType === 'LDAP') {
              //LDAP인 경우에만 다른곳으로 이동
              let menu = store.getters.getMenuByPath(to.path, to.meta?.menuPath);
              if (!menu) {
                await next(store.getters.getMenus[0]?.lowerMenuList[0]?.lowerMenuList[0]?.url);
                return;
              }
            }
            if (!store.getters.selectedAdAccount) {
              if (store.getters.getAdAccountList.length > 0) {
                store.commit('selectAdAccount', store.getters.getAdAccountList[0].id);
                await next();
              } else {
                await next({name: 'StartAdAccount'});
              }
            } else {
              await next();
            }
          }
        }
      },

      {
        path: 'guide',
        components: {
          default: () => import(/* webpackChunkName: "PlatformGuide" */ '@/pages/guide/PlatformGuide'),
          menu: emptyMenu
        },
        meta: {
          noAdAccountSelector: true
        }
      },
      {
        path: 'introManagement',
        component: () => import(/* webpackChunkName: "IntroManagement" */ '@/pages/intro/IntroManagement'),
        meta: {
          menuPath: '/introManagement',
          noAdAccountSelector: true
        }
      },
      {
        path: 'adgame',
        component: routerViewComponent,
        children: [
          {
            path: 'list',
            name: 'AdGameList',
            component: () => import(/* webpackChunkName: "IntroManagement" */ '@/pages/adGames/AdGameList'),
            meta: {
              authLevelFromAdAccount: true,
            }
          },
          {
            path: 'new',
            name: 'AdGameNew',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/adGames/AdGameNewOrEdit'),
            meta: {
              menuPath: '/adgame/list',
              authLevelFromAdAccount: true,
            }
          },
          {
            path: ':appMasterId/edit',
            name: 'AdGameEdit',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/adGames/AdGameNewOrEdit'),
            meta: {
              menuPath: '/adgame/list',
              authLevelFromAdAccount: true,
            }
          }
        ]
      },
      {
        path: 'missions',
        component: routerViewComponent,
        children: [
          {
            path: 'list',
            name: 'MissionsList',
            component: () => import(/* webpackChunkName: "Missions" */ '@/pages/missions/List')
          },
          {
            path: 'new',
            name: 'MissionsNew',
            component: () => import(/* webpackChunkName: "Missions" */ '@/pages/missions/NewOrEdit'),
            meta: {
              menuPath: '/missions/list'
            }
          },
          {
            path: 'user-search',
            name: 'MissionsUserSearch',
            component: () => import(/* webpackChunkName: "Missions" */ '@/pages/missions/UserSearch')
          },
          {
            path: 'report',
            name: 'MissionsReport',
            component: () => import(/* webpackChunkName: "Missions" */ '@/pages/missions/Report')
          },
          {
            path: ':missionId/edit',
            component: () => import(/* webpackChunkName: "Missions" */ '@/pages/missions/NewOrEdit'),
            meta: {
              menuPath: '/missions/list'
            }
          },
          {
            path: ':missionId',
            component: () => import(/* webpackChunkName: "Missions" */ '@/pages/missions/Detail'),
            meta: {
              menuPath: '/missions/list'
            }
          }
        ]
      },

      {
        path: 'survey',
        component: routerViewComponent,
        children: [
          {
            path: 'list',
            name: 'SurveyList',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/survey/SurveyList'),
            meta: {
              authLevelFromAdAccount: true,
            }
          },
          {
            path: 'new',
            name: 'SurveyCreate',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/survey/SurveyCreate'),
            meta: {
              menuPath: '/survey/list',
            }
          },
          {
            path: ':surveyId/edit',
            name: 'SurveyEdit',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/survey/SurveyEdit'),
            meta: {
              menuPath: '/survey/list',
            }
          },
          {
            path: ':surveyId/question-edit',  //TODO:path 확인
            name: 'QuestionEdit',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/survey/SurveyQuestionEdit.vue'),
            meta: {
              menuPath: '/survey/list',
            },
          },
          {
            path: 'user',
            name: 'SurveyUserInfo',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/survey/SurveyUserInfo'),
            meta: {
              menuPath: '/survey/list',
            }
          },
          {
            path: ':surveyId/result',
            name: 'SurveyResult',
            component: () => import(/* webpackChunkName: "Survey" */ '@/pages/survey/SurveyResult'),
            meta: {
              menuPath: '/survey/list',
            }
          },
        ]
      },

      {
        path: 'admin/talk-channels',
        component: routerViewComponent,
        children: [
          {
            path: 'list',
            name: 'TalkChannelList',
            component: () => import(/* webpackChunkName: "TalkChannel" */ '@/pages/talkchannel/TalkChannelList'),
            meta: {
              noAdAccountSelector: true
            },
            props: {
              pageType: 'admin'
            }
          },
        ]
      },
      {
        path: 'talk-channels',
        component: routerViewComponent,
        children: [
          {
            path: 'list',
            name: 'TalkChannelList',
            component: () => import(/* webpackChunkName: "TalkChannel" */ '@/pages/talkchannel/TalkChannelList'),
            meta: {
            },
            props: {
              pageType: ''
            }
          }
        ]
      },
      {
        path: '',
        name: 'AdminManagement',
        meta: {
          noAdAccountSelector: true
        },
        component: routerViewComponent
        ,
        children: [
          {
            path: 'menus',
            component: () => import(/* webpackChunkName: "MenuList" */ '@/pages/auth/MenuList')
          },
          {
            path: 'menus/new',
            component: () => import(/* webpackChunkName: "MenuNew" */ '@/pages/auth/MenuNew'),
            meta: {
              menuPath: '/menus'
            }
          },
          {
            path: 'menus/:menuId/edit',
            name: 'menuEdit',
            component: () => import(/* webpackChunkName: "MenuEdit" */ '@/pages/auth/MenuEdit')
          },
          {
            path: 'group-menu-management',
            name: 'menuManagement',
            component: () => import(/* webpackChunkName: "MenuManagement" */ '@/pages/auth/MenuManagement'),
            meta: {
              menuPath: '/groups'
            }
          },
          {
            path: 'users/management',
            component: () => import(/* webpackChunkName: "MenuList" */ '@/pages/auth/UserManagement')
          },
          {
            path: 'user/intro',
            name: 'kakaoPolicyIntro',
            components: {
              default: () => import(/* webpackChunkName: "KakaoPolicyIntro" */ '@/pages/user/registration/KakaoPolicyIntro'),
              menu: emptyMenu
            },
            meta: {
              noAdAccountSelector: true
            }
          },
          {
            path: '/user/registration',
            name: 'userRegistration',
            components: {
              default: () => import(/* webpackChunkName: "UserRegistartion" */ '@/pages/user/registration/UserRegistration'),
              menu: emptyMenu
            },
            meta: {
              noAdAccountSelector: true
            }
          },
          {
            path: 'groups',
            component: () => import(/* webpackChunkName: "GroupList" */ '@/pages/auth/GroupList')
          },
          {
            path: 'groups/new',
            component: () => import(/* webpackChunkName: "GroupList" */ '@/pages/auth/GroupNew'),
            meta: {
              menuPath: '/groups'
            }
          },

          {
            path: 'admin/status/apps',
            component: () => import(/* webpackChunkName: "AppList" */ '@/components/admin/apps/AdminAppList')
          },
          {
            path: 'admin/status/ad-accounts',
            component: () => import(/* webpackChunkName: "AdminStatus" */ '@/components/admin/status/AdminStatus'),
            props: {
              pageType: "ADACCOUNTS"
            }
          },

          {
            path: 'admin/status/dashboard',
            component: () => import(/* webpackChunkName: "AdminStatus" */ '@/components/admin/status/AdminStatus')
          },
          {
            path: 'admin/campaigns',
            component: () => import(/* webpackChunkName: "AdminStatus" */ '@/components/admin/status/AdminStatus'),
            props: {
              pageType: "ALLCAMPAIGNS"
            }
          },
          {
            path: 'admin/campaigns/advertisers',
            component: () => import(/* webpackChunkName: "AdminStatus" */ '@/components/admin/status/AdminStatus'),
            props: {
              pageType: "BYADVERTISER"
            }
          },
          {
            path: 'admin/campaigns/apps',
            component: () => import(/* webpackChunkName: "AdminStatus" */ '@/components/admin/status/AdminStatus'),
            props: {
              pageType: "BYAPP"
            }
          },

          //TODO: 아래는 임시 페이지들
          {
            path: 'notitalk',
            component: emptyPage
          },
          {
            path: 'user-search',
            component: emptyPage
          },
          {
            path: 'change-log',
            component: () => import('@/components/admin/changeLog/AdminChangeLog.vue'),
          }
        ]
      },
      {
        path: 'ad-account',
        component: routerViewComponent,
        children: [
          {
            path: 'start',
            name: 'StartAdAccount',
            components: {
              default: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/create/StartAdAccount.vue'),
              menu: emptyMenu
            },
            meta: {noAdAccountSelector: true, menuPath: '/user/management/ad-account'}
          },
          {
            path: 'find',
            name: 'FindAdAccount',
            components: {
              default: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/create/FindAdAccount.vue'),
              menu: emptyMenu
            },
            meta: {noAdAccountSelector: true, menuPath: '/user/management/ad-account'}
          },
          {
            path: 'new',
            name: 'CreateAdAccount',
            components: {
              default: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/create/CreateAdAccount.vue'),
              menu: emptyMenu
            },
            meta: {noAdAccountSelector: true, menuPath: '/user/management/ad-account'}
          },
          {
            path: '',
            name: 'adAccountManagement',
            component: routerViewComponent,
            meta: {authLevelFromAdAccount: true},
            children: [
              {
                path: 'information',
                name: 'AdAccountInformation',
                component: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/management/AdAccountInformation.vue'),
              },
              {
                path: 'members',
                name: 'AdAccountMembers',
                component: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/management/AdAccountMembers.vue'),
              },
              {
                path: 'apps',
                name: 'AdAccountApps',
                component: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/management/AdAccountApps.vue'),
              },
              {
                path: 'change-logs',
                name: 'AdAccountChangeLogs',
                component: () => import(/* webpackChunkName: "AdAccount" */ '@/components/adaccount/management/AdAccountChangeLog')
              }
            ]
          }
        ]
      },
      {
        path: 'groups/new',
        component: () => import(/* webpackChunkName: "GroupList" */ '@/pages/auth/GroupNew')
      },
      {
        path: 'user/management',
        name: '내 정보 관리',
        component: routerViewComponent,
        meta: {
          noAdAccountSelector: true
        },
        children: [
          {
            path: 'ad-account',
            name: 'MyAdAccountManagement',
            component: () => import(/* webpackChunkName: "MyAdAccountManagement" */ '@/pages/user/management/MyAdAccountManagement.vue')
          },
          {
            path: 'admin-account',
            name: 'MyAdminAccountManagement',
            component: () => import(/* webpackChunkName: "MyAdminAccountManagement" */ '@/pages/user/management/MyAdminAccountManagement.vue')
          }
        ]
      },
      {
        path: 'pr',
        name: 'preg',
        component: routerViewComponent,
        children: [
          {
            path: 'alimtalk',
            name: 'alimtalkList',
            component: () => import(/* webpackChunkName: "alimtalkList" */ '@/pages/preg/alimtalk/AlimtalkList'),
            meta: {noAdAccountSelector: true},
          },
          {
            path: 'campaigns/:campaignId/pregs/:pregId/detail-edit',
            name: 'pregDetailModify',
            component: () => import(/* webpackChunkName: "pregDetailEdit" */ '@/pages/preg/DetailEdit'),
            meta: {
              pageTitle: "사전예약 상세 수정",
              menuPath: '/pr/list'
            }
          },
          {
            path: 'campaigns/:campaignId/pregs/:pregId/additional-info-edit',
            name: 'pregAdditionalModify',
            component: () => import(/* webpackChunkName: "pregDetailEdit" */ '@/pages/preg/AdditionalInfoEdit'),
            meta: {
              pageTitle: "사전예약 추가 정보 수정",
              menuPath: '/pr/list'
            }
          },
          {
            path: 'result-file',
            name: 'pregResultFileRequest',
            component: () => import(/* webpackChunkName: "pregResultFileRequest" */ '@/pages/preg/PregResultFileRequest')
          },
          {
            path: 'list',
            name: 'pregSummaryList',
            component: () => import('@/pages/preg/PregSummaryList')
          },
          {
            path: 'register',
            name: 'pregRegister',
            component: () => import('@/pages/preg/PregRegister'),
            meta: {
              pageTitle: "사전예약 최초 등록",
              menuPath: '/pr/list'
            }
          },
          {
            path: 'campaigns/:gapCampaignId/pregs/:pregId/default-edit',
            name: 'pregModify',
            component: () => import('@/pages/preg/PregModify'),
            meta: {
              pageTitle: "사전예약 기본 정보 수정",
              menuPath: '/pr/list'
            }
          },
          {
            path: 'campaigns/:campaignId/pregs/:pregId/nickname-edit',
            name: 'pregNicknameEdit',
            component: () => import('@/pages/preg/nickname/PregNicknameEdit'),
            meta: {
              pageTitle: "닉네임선점 수정",
              menuPath: '/pr/list'
            }
          },
          {
            path: 'user',
            name: 'pregUserLog',
            component: () => import(/* webpackChunkName: "PregUserInfo" */ '@/pages/preg/PregUserInfo'),
            meta: {
              pageTitle: "사전예약 이용자 조회",
              noAdAccountSelector: true
            }
          },
        ]
      },
      {
        path: 'coupons',
        component: routerViewComponent,
        meta: {authLevelFromAdAccount: true},
        children: [
          {
            path: 'list',
            name: 'CouponList',
            component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponList'),
            meta: {
              menuPath: '/coupons/list'
            }
          },
          {
            path: 'inbox',
            name: 'CouponInbox',
            component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponInbox'),
            meta: {
              noAdAccountSelector: true
            }
          },
          {
            path: 'new',
            name: 'CouponCreate',
            component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponCreate'),
            meta: {
              menuPath: '/coupons/list'
            },
            props: {
              pageType: 'new'
            }
          },
          {
            path: ':couponId',
            name: 'Coupon',
            component: routerViewComponent,
            children: [
              {
                path: 'view',
                name: 'CouponView',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponCreate'),
                meta: {
                  menuPath: '/coupons/list'
                },
                props: {
                  pageType: 'view'
                }
              },
              {
                path: 'edit',
                name: 'CouponEdit',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponCreate'),
                meta: {
                  menuPath: '/coupons/list'
                },
                props: {
                  pageType: 'edit'
                }
              },
              {
                path: 'upload',
                name: 'CouponUploadNumber',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponUploadNumber'),
                meta: {
                  menuPath: '/coupons/list'
                }
              },
              {
                path: 'statistics',
                name: 'CouponStatistics',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponStatistics'),
                meta: {
                  menuPath: '/coupons/list'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'admin/status/coupons',
        component: routerViewComponent,
        meta: {
          noAdAccountSelector: true
        },
        children: [
          {
            path: 'list',
            name: 'AdminCouponList',
            component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponList'),
            meta: {
              menuPath: '/admin/status/coupons/list'
            }
          },
          {
            path: ':couponId',
            name: 'AdminCoupon',
            component: routerViewComponent,
            children: [
              {
                path: 'view',
                name: 'AdminCouponView',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponCreate'),
                meta: {
                  menuPath: '/admin/status/coupons/list'
                },
                props: {
                  pageType: 'view'
                }
              },
              {
                path: 'edit',
                name: 'AdminCouponEdit',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponCreate'),
                meta: {
                  menuPath: '/admin/status/coupons/list'
                },
                props: {
                  pageType: 'edit'
                }
              },
              {
                path: 'upload',
                name: 'AdminCouponUploadNumber',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponUploadNumber'),
                meta: {
                  menuPath: '/admin/status/coupons/list'
                }
              },
              {
                path: 'statistics',
                name: 'CouponStatistics',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/coupon/CouponStatistics'),
                meta: {
                  menuPath: '/admin/status/coupons/list'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'admin/status/shipping',
        component: routerViewComponent,
        meta: {
          noAdAccountSelector: true
        },
        children: [
          {
            path: 'list',
            name: 'AdminCouponList',
            component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/shipping/ShippingList'),
            meta: {
              menuPath: '/admin/status/shipping/list'
            }
          },
          {
            path: ':shippingId',
            name: 'AdminShipping',
            component: routerViewComponent,
            children: [
              {
                path: 'view',
                name: 'AdminShippingView',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/shipping/ShippingCreate'),
                meta: {
                  menuPath: '/admin/status/shipping/list'
                },
                props: {
                  pageType: 'view'
                }
              },
              {
                path: 'edit',
                name: 'AdminShippingEdit',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/shipping/ShippingCreate'),
                meta: {
                  menuPath: '/admin/status/shipping/list'
                },
                props: {
                  pageType: 'edit'
                }
              },
              {
                path: 'statistics',
                name: 'ShippingStatistics',
                component: () => import(/* webpackChunkName: "Coupon" */ '@/pages/shipping/ShippingStatistics'),
                meta: {
                  menuPath: '/admin/status/shipping/list'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'admin/status/report',
        component : routerViewComponent,
        meta:{
          noAdAccountSelector: true
        },
        children: [
          {
            path: '',
            name: 'AdminReportList',
            component: () => import(/* webpackChunkName: "Report" */ '@/pages/report/Report.vue'),
            meta:{
              pageTitle : "톡채널 메시지 목록",
              menuPath: '/admin/status/report',
            }
          },
          {
            path: ':reportId',
            name: 'AdminReportResult',
            component: () => import(/* webpackChunkName: "Report" */ '@/pages/report/ReportResult.vue'),
            meta:{
              pageTitle : "톡채널 메시지 결과조회",
              menuPath: '/admin/status/report',
            }
          }
        ],
      },
      {
        path: '/draw',
        component: routerViewComponent,
        children: [
          {
            path: 'new',
            name: 'DrawNew',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawRegister'),
            meta: {
              pageTitle: 'Draw 등록',
              menuPath: '/draw/list'
            }
          },
          {
            path: ':drawId/management',
            name: 'DrawManagement',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawContainer'),
            meta: {
              pageTitle: 'Draw 등록',
              menuPath: '/draw/list'
            }
          },
          {
            path: 'list',
            name: 'DrawList',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawList'),
            meta: {
              pageTitle: 'Draw 목록'
            }
          },
          {
            path: ':drawId/edit',
            name: 'DrawEdit',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawEdit'),
            meta: {
              pageTitle: '기본 정보 수정',
              menuPath: '/draw/list'
            }
          },
          {
            path: ':drawId/detail-edit',
            name: 'DrawDetailEdit',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawDetailEdit'),
            meta: {
              pageTitle: '상세 정보 수정',
              menuPath: '/draw/list'
            }
          },
          {
            path: ':drawId/prize-list',
            name: 'DrawPrizeInfo',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawPrizeList'),
            meta: {
              pageTitle: 'Draw의 Prize 목록',
              menuPath: '/draw/list'
            }
          },
          {
            path: 'ad-account/ticket-log',
            name: 'TicketLog',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/TicketLog'),
            meta: {
              pageTitle: '이용권 발급 및 사용 내역',
            }
          },
          {
            path: 'ticket-log',
            name: 'AllTicketLog',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/TicketLog'),
            meta: {
              pageTitle: '이용권 발급 및 사용 내역',
              noAdAccountSelector: true
            },
            props: {
              pageType: 'admin'
            }
          },
          {
            path: ':drawId/ticket-log',
            name: 'TicketLogForDraw',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/TicketLog'),
            meta: {
              pageTitle: '이용권 발급 및 사용 내역'
            }
          },
          {
            path: 'stats',
            name: 'DrawStats',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawStats'),
            meta: {pageTitle: '지표'},
          },
          {
            path: 'delivery',
            name: 'DrawDelivery',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/UnableShipPrizeList'),
            meta: {pageTitle: '경품 일괄 지급'},
          },
          {
            path: 'win-log',
            name: 'DrawWinLog',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/WinUserList'),
            meta: {pageTitle: '당첨자 목록'},
          },
          {
            path: ':drawId/prize-settings',
            name: 'DrawPrizeSettings',
            component: () => import(/* webpackChunkName: "Draws" */ '@/pages/draw/DrawPrizeSettings'),
            meta: {
              pageTitle: '경품 설정',
              menuPath: '/draw/list'
            }
          },
        ]
      },
      {
        path: 'shipping',
        component: routerViewComponent,
        meta: {authLevelFromAdAccount: true},
        children: [
          {
            path: 'list',
            name: 'ShippingList',
            component: () => import(/* webpackChunkName: "Shipping" */ '@/pages/shipping/ShippingList'),
            meta: {
              menuPath: '/shipping/list'
            }
          },
          // {
          //   path: 'inbox',
          //   name: 'ShippingInbox',
          //   component: () => import(/* webpackChunkName: "Shipping" */ '@/components/shipping/ShippingInbox'),
          //   meta: {
          //     noAdAccountSelector: true
          //   }
          // },
          {
            path: 'new',
            name: 'ShippingCreate',
            component: () => import(/* webpackChunkName: "Shipping" */ '@/pages/shipping/ShippingCreate'),
            meta: {
              menuPath: '/shipping/list'
            },
            props: {
              pageType: 'new'
            }
          },
          {
            path: ':shippingId',
            name: 'Shipping',
            component: routerViewComponent,
            children: [
              {
                path: 'view',
                name: 'ShippingView',
                component: () => import(/* webpackChunkName: "Shipping" */ '@/pages/shipping/ShippingCreate'),
                meta: {
                  menuPath: '/shipping/list'
                },
                props: {
                  pageType: 'view'
                }
              },
              {
                 path: 'edit',
                 name: 'ShippingEdit',
                 component: () => import(/* webpackChunkName: "Shipping" */ '@/pages/shipping/ShippingCreate'),
                 meta: {
                   menuPath: '/shipping/list'
                 },
                 props: {
                   pageType: 'edit'
                 }
              },
              {
                 path: 'statistics',
                 name: 'ShippingStatistics',
                 component: () => import(/* webpackChunkName: "Shipping" */ '@/pages/shipping/ShippingStatistics'),
                 meta: {
                   menuPath: '/shipping/list'
                 }
              },
            ]
          }
        ]
      },
      {
        path: 'ranking',
        component: routerViewComponent,
        meta: {authLevelFromAdAccount: true},
        children: [
          {
            path: 'list',
            name: 'RankingList',
            component: () => import(/* webpackChunkName: "Ranking" */ '@/pages/ranking/RankingList.vue'),
            meta: {
              menuPath: '/ranking/list'
            }
          },
          {
            path: 'history',
            name: 'RankingHistory',
            component: () => import(/* webpackChunkName: "Ranking" */ '@/pages/ranking/RankingHistory.vue'),
            meta: {
              menuPath: '/ranking/history'
            }
          },
          {
            path: 'statistics',
            name: 'RankingStatistics',
            component: () => import(/* webpackChunkName: "Ranking" */ '@/pages/ranking/RankingStatistics.vue'),
            meta: {
              menuPath: '/ranking/statistics'
            }
          },
          {
            path: 'new',
            name: 'RankingCreateTemplate',
            component: () => import(/* webpackChunkName: "Ranking" */ '@/pages/ranking/RankingCreateTemplate.vue'),
            meta: {
              menuPath: '/ranking/list'
            },
            props: {
              pageType: 'new'
            }
          },
          {
            path: ':pregMasterId',
            name: 'Ranking',
            component: routerViewComponent,
            children: [
              {
                path: 'edit',
                name: 'RankingEdit',
                component: () => import(/* webpackChunkName: "Ranking" */ '@/pages/ranking/RankingCreateTemplate'),
                meta: {
                  menuPath: '/ranking/list'
                },
                props: {
                  pageType: 'edit'
                }
              },
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/Login.vue'),
    meta: {
      authNotRequired: true
    }
  },
  {
    path: '/login/ldap',
    name: 'ldapLogin',
    component: () => import('@/pages/login/LdapLogin.vue'),
    meta: {
      authNotRequired: true
    }
  },
  {
    path: '/login/kakao',
    name: 'kakaoLogin',
    component: () => import('@/pages/login/KakaoLogin.vue'),
    meta: {
      authNotRequired: true
    }
  },
  {
    path: '*',
    name: 'page404',
    component: () => import('@/pages/Page404.vue'),
    meta: {
      authNotRequired: true
    }
  }
];

const router = new VueRouter({
                               mode: 'history',
                               routes,
                               scrollBehavior(to, from, savedPosition) {
                                 const mainConatiner = document.getElementById('main');
                                 if (mainConatiner) {
                                   mainConatiner.scrollTop = 0;
                                 }
                                 return {x: 0, y: 0}
                               }
                             });

router.beforeEach(
  async (to, from, next) => {
    const isSignedUp = (await store.dispatch("getSignedUp"));

    if (store.getters.hasAuth &&
        (store.getters.getUser?.allowedChangeKakaoPolicy === false // 배포일 전 로그인
         || store.getters.getUser === null)) {

      if(to.path === '/user/registration') next()
      else if(to.path === '/user/intro') next()
      else if(store.getters.getUser) next('/user/intro')
      else  next('/user/registration')
      return;
    } // 최초 로그인


    if ((to.path === '/user/registration' && isSignedUp) || (to.path === '/user/intro' && isSignedUp)) { // 가입되어있는데 가입 페이지로 가려고 하면 대시보드로
      next('/')
    } else if (to.path.startsWith('/login')) {            // 로그인 페이지 접근 시 체크
      if (!store.getters.hasAuth) {                       // 로그인 안했으면 로그인으로, 로그인 했으면 대시보드로
        next();
      } else {
        next('/');
      }
    } else {
      if (to.meta.authNotRequired) {                      // 권한 필요 없는 페이지면 통과
        next();
      } else if (store.getters.hasAuth) {                 // 로그인 상태
        if (!isSignedUp) {
          if (store.getters.getAuthType === "LDAP") {       // LDAP이 미가입상태면 접속 불가
            await store.dispatch("logout");
            alert("광고 플랫폼에 등록되지 않은 유저입니다. 관리자에게 문의하세요.");
          } else {
            next('/user/registration');                   // 가입 안했으면 가입 페이지로
          }
        } else {
          if (!store.getters.menuTree ||              //불러온 메뉴가 없거나, 광고계정이 선택되지 않은 상태라면
              store.getters.menuTree === 0 ||
              !store.getters.selectedAdAccount) {
            await store.dispatch('refreshAdminMenu');
          }                           // 메뉴를 불러오고
          if (!store.getters.hasAuth) { //메뉴 불러오는중에 쿠키 이슈가 있었다면 권한이 사라지고 이동됨
            //removeAuth에 의해 login페이지로 이동됨
            console.log("auth removed");
          } else if (!!store.getters.getMenuByPath(to.path, to.meta.menuPath)) {  // 내 메뉴에 있으면 이동
            next();
          } else {
            alert("해당 메뉴에 접근 할 수 있는 권한이 없습니다.")?.then(
              () => {
                const firstMenu = store.getters.getFirstMenu;
                if (firstMenu) {
                  next(firstMenu.url);
                } else {
                  store.dispatch("logout");
                }
              }
            );
          }
        }
      } else {
        next(loginPageUrl); // 로그인 안했으면 로그인 페이지로
      }
    }
  }
);

router.afterEach((to, from) => {
  store.commit("setCurrentRoute", to);
  if (!to.path.startsWith('/login')) {
    localStorage.setItem('lastVisited', to.fullPath);
  }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (isNavigationFailure(err, NavigationFailureType.redirected) ||
        isNavigationFailure(err, NavigationFailureType.duplicated) ||
        isNavigationFailure(err, NavigationFailureType.cancelled)) {
      // navigation failure는 에러로 남기지 않음
    }
    else{
      throw err;
    }
  });
}

export default router;

